import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import config from "@/config";
import { useNavigate } from "react-router-dom";

const CompanyCard = ({ company }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(config.routes.company + `${company.Pk}`);
        window.scroll({ top: 0, behavior: 'smooth' });
    }
    return (
        <div
            onClick={handleClick}
            className="bg-white border rounded-lg shadow-md p-4 group transition-all cursor-pointer hover:bg-green-100 duration-100 hover:border-primary">
            <div className="flex gap-2 lg:gap-4">
                {/* Logo */}
                <div className="w-20 h-20 aspect-square	rounded-lg flex items-center justify-center">
                    <img
                        // src={company.logo}
                        src={config.ImageConfig.getLogo(company.PhotoCompany)}
                        alt={company.CompanyName}
                        className="w-full h-full object-contain rounded-lg"
                    />
                </div>

                {/* Company Info */}
                <div className="w-3/4 max-h-24 space-y-2">
                    <h3 className="font-semibold text-lg text-gray-800  group-hover:text-primary hover:underline line-clamp-1">
                        {company.CompanyName}
                    </h3>
                    <p className={"text-sm texy-gray-500 line-clamp-2"} dangerouslySetInnerHTML={{ __html: company.Description }}></p>
                    <p className="text-sm text-gray-500">{company.category}</p>
                </div>
            </div>

            {/* Job Count */}
            <div className="mt-2 pt-2 border-t border-gray-200">
                <div className="flex items-center justify-between">
                    <span className=" font-semibold  group-hover:text-primary "><FontAwesomeIcon icon={faBriefcase}
                        className={"me-2 text-yellow-500"} />Đang tuyển dụng</span>
                    <span className="text-sm font-medium bg-secondary-bg text-secondary px-4 py-1 rounded-xl">
                        {company.jobCount} Việc làm
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CompanyCard;
